import { configureStore as configureStoreToolkit } from '@reduxjs/toolkit';
// import reduxImmutableStateInvariant from 'redux-immutable-state-invariant';
import thunk from 'redux-thunk';
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import rootReducer from '../reducers';
import setBrowserFingerPrint from '../redux-middleware/set-browser-fingerprint.js';
import storage from 'redux-persist/lib/storage';

const logger = store => next => action => {
  const result = next(action);
  return result;
};

const crashReporter = store => next => action => {
  try {
    return next(action);
  } catch (err) {
    console.error('Caught an exception!', err);
    // Raven.captureException(err, {
    //   extra: {
    //     action,
    //     state: store.getState()
    //   }
    // });
    throw err;
  }
};

function configureStoreProd(initialState) {
  const middlewares = [
    setBrowserFingerPrint(false),
    // Add other middleware on this line...

    // thunk middleware can also accept an extra argument to be passed to each thunk action
    // https://github.com/gaearon/redux-thunk#injecting-a-custom-argument
    logger,
    crashReporter
  ];

  const persistConfig = {
    key: 'root',
    storage: storage,
    whitelist: [
      // 'products', 
      // 'grid', 
      'request', 
      'eossCouponsReducer', 
      'fleek'
    ],
  };

  const persistedReducer = persistReducer(persistConfig, rootReducer);

  const store = configureStoreToolkit({
    reducer: persistedReducer,
    preloadedState: initialState,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
      serializableCheck: false,

      // serializableCheck: {
      //   ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      // },
    }).concat([...middlewares])
  });

  const persistor = persistStore(store);

  return { store, persistor };
}

function configureStoreDev(initialState) {
  const middlewares = [
    logger,
    crashReporter,
    // Add other middleware on this line...

    // Redux middleware that spits an error on you when you try to mutate your state either inside a dispatch or between dispatches.
    // reduxImmutableStateInvariant(),

    // thunk middleware can also accept an extra argument to be passed to each thunk action
    // https://github.com/gaearon/redux-thunk#injecting-a-custom-argument
  ];

  const persistConfig = {
    key: 'root',
    storage: storage,
    whitelist: [
      // 'products', 
      // 'grid', 
      'request', 
      'eossCouponsReducer', 
      'fleek'
    ],
  };

  const persistedReducer = persistReducer(persistConfig, rootReducer);

  const store = configureStoreToolkit({
    reducer: persistedReducer,
    preloadedState: initialState,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false

      // serializableCheck: {
      //   ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      // },
    }).concat(middlewares)
  });

  const persistor = persistStore(store);
  
  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../reducers', () => {
      const nextReducer = require('../reducers').default; // eslint-disable-line global-require
      store.replaceReducer(nextReducer);
    });
  }

  return { store, persistor };
}

const configureStore =
  process.env.NODE_ENV === 'production' ? configureStoreProd : configureStoreDev;

export default configureStore;
